import SparkMD5 from "spark-md5";
import { HttpService } from ".";
import { APIHOSTLINTAS } from "../config";
const chunkSize = 1 * 1024 * 1024 * 15; // The size of each chunk, set to 15 Megabyte
// Use the Blob.slice method to split the file.
// This method is also used differently in different browsers.
const blobSlice = File.prototype.slice;

export const getPager = (
  totalItems: number,
  currentPage: number,
  pageSize: number,
  direction: string,
  orderBy: string
) => {
  try {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || 10;

    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 3 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    // calculate start and end item indexes
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i);

    const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
      (i) => startPage + i
    );

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      page: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
      direction: direction,
      orderBy: orderBy,
    };
  } catch (e) {
    console.log("error at getPager: ", e);
  }
};

export const cekDataApi = (respons: any, masterTypeId: string) => {
  let isValid = true;
  let errormessage = "";
  if (respons.status !== 200) {
    errormessage = respons.data.message;
    isValid = false;
  }

  if (respons.data.statusCode !== 200) {
    errormessage = `Data with id ${masterTypeId} is not exist. Please contact your admin`;
    isValid = false;
  }
  return {
    isValid,
    errormessage,
  };
};

export const messageLoading = () => {
  const param = {
    type: "info",
    title: `Please Wait...`,
    // confirmBtnBsStyle: 'success',
    // confirmBtnText: 'Ok',
    message: "",
    showConfirm: false,
    showCancel: false,
    focusConfirmBtn: false,
    closeOnClickOutside: false,
  };

  return {
    param,
  };
};

export const messageLoadingParam = (message: string) => {
  const param = {
    type: "info",
    title: `Please Wait...`,
    // confirmBtnBsStyle: 'success',
    // confirmBtnText: 'Ok',
    message: message,
    showConfirm: false,
    showCancel: false,
    focusConfirmBtn: false,
    closeOnClickOutside: false,
  };

  return {
    param,
  };
};
export const messageLoadingParamFailed = (message: string) => {
  const param = {
    type: "danger",
    title: `Failed...`,
    // confirmBtnBsStyle: 'success',
    // confirmBtnText: 'Ok',
    message: message,
    showConfirm: false,
    showCancel: false,
    focusConfirmBtn: false,
    closeOnClickOutside: false,
  };
  return param;
};

export const messageAction = (res: any, action: string) => {
  let isSucces = true;
  let errorMessage = "";
  const param = {
    type: "success",
    title: `Data ${action}!`,
    confirmBtnBsStyle: "success",
    confirmBtnText: "Ok",
    message: "",
    showCancel: false,
    focusConfirmBtn: false,
  };
  if (res.data) {
    // const message = res.status === 413 ? 'File too large. Total maximum size is 10 MB' : res.data.message;
    if (res.status !== 200) {
      isSucces = false;
      errorMessage =
        typeof res.data.message === "string"
          ? res.data.message
          : res.data.message.Error;

      if (errorMessage.includes("modules_code_application_id_key")) {
        errorMessage = "Menu already exist";
      }
    } else {
      if (res.data.statusCode !== 200) {
        isSucces = false;
        errorMessage = res.data.message.Error;
      } else {
        param.message = res.data.message.Error;
      }
    }
  } else {
    isSucces = false;
    errorMessage = res.message;
  }
  if (!isSucces) {
    param.type = "danger";
    param.title = "Attention!";
    param.confirmBtnBsStyle = "primary";
    param.message = errorMessage;
  }
  return {
    isSucces,
    param,
  };
};

export const hashFile = (file: any) => {
  return new Promise((resolve, reject) => {
    const chunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();
    function loadNext() {
      const start = currentChunk * chunkSize;
      const end =
        start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    fileReader.onload = (e: any) => {
      spark.append(e.target.result); // Append array buffer
      currentChunk += 1;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        const result = spark.end();
        // If result s are used as hash values only, if the contents of the file are the same and the names are different
        // You cannot keep two files if you want to.So add the file name.
        const sparkMd5 = new SparkMD5();
        sparkMd5.append(result);
        sparkMd5.append(file.name);
        const hexHash = sparkMd5.end();
        resolve(hexHash);
      }
    };
    fileReader.onerror = () => {
      console.warn("File reading failed!");
    };
    loadNext();
  }).catch((err) => {
    console.log(err);
  });
};

export const sortList = (list: any, order: string, property: string) => {
  // console.log(list, order, property);
  let direction: number;
  if (order === "ASC") {
    direction = 1;
  } else {
    direction = -1;
  }
  list.sort((a: any, b: any) => {
    let comparison = 0;
    if (a[property] > b[property]) {
      comparison = 1 * direction;
    } else if (a[property] < b[property]) {
      comparison = -1 * direction;
    }
    return comparison;
  });
  return list;
};

export const getExtentionImage = (string: string, isIcon: boolean): string => {
  if (isIcon) {
    switch (string) {
      case "image/png":
        return ".png";

      case "image/svg+xml":
        return ".svg";

      default:
        return "";
    }
  } else {
    switch (string) {
      case "image/jpeg":
        return ".jpeg";

      case "image/jpg":
        return ".jpg";

      case "image/png":
        return ".png";

      default:
        return "";
    }
  }
};

export const sortAlphanumeric = (
  list: any,
  order: string,
  property: string
) => {
  let direction: number;
  if (order === "ASC") {
    direction = 1;
  } else {
    direction = -1;
  }
  const regex = /^([a-z]*)(\d*)/i;
  list.sort((a: any, b: any) => {
    let _a = a[property].match(regex);
    let _b = b[property].match(regex);
    let comparison = 0;

    if (_a[1] < _b[1]) return (comparison = -1 * direction);
    if (_a[1] > _b[1]) return (comparison = 1 * direction);

    if (direction === 1) {
      comparison = parseInt(_a[2]) - parseInt(_b[2]);
    } else {
      comparison = parseInt(_b[2]) - parseInt(_a[2]);
    }

    // if(_n == 0){
    //   return list.sort(c.substr(_a[0].length), d.substr(_b[0].length));
    // }
    return comparison;
  });
  return list;
};

export const getGeneralParameterByKey = async (headers: any, key: string) => {
  const res = await HttpService.post(
    `${APIHOSTLINTAS}/auth/generalparameters`,
    {
      action: "GET_BY_KEY",
      data: {
        ParameterKey: key,
      },
    },
    headers
  );
  return res;
};

export const updateApprovalPolicyDate = async (headers: any, userID: number) => {
  const res = await HttpService.post(
    `${APIHOSTLINTAS}/auth/user`,
    {
      Action: "UPDATE_APPROVAL_POLICY_DATE",
      User: {
        ID: userID,
      },
    },
    headers
  );
  return res;
};

export const mapAndSortMenu = (modules: any, mode: string) => {
  if (mode === "parent") {
    return modules
      .filter(
        (val: any) =>
          val.ModuleParentID === 0 &&
          val.ApplicationCode.toString().toLowerCase() === "lintas"
      )
      .sort((a: any, b: any) => a.ModuleSequencNo - b.ModuleSequenceNo)
      .map((item: any) => ({
        id: item.ModuleID,
        name: item.ModuleCode,
        url: item.ModulePath,
        icon: item.ModuleIconPath,
        isParent: item.IsParent,
        children: [] as object[],
      }));
  }

  return modules
    .filter((val: any) => val.ModuleParentID > 0)
    .sort((a: any, b: any) => a.ModuleSequencNo - b.ModuleSequencNo)
    .map((item: any) => ({
      name: item.ModuleCode,
      url: item.ModulePath,
      icon: item.ModuleIconPath,
      parentID: item.ModuleParentID,
    }));
};

export const newMessageAction = (res: any, action: string) => {
  let isSucces = true;
  let errorMessage = "";
  const param = {
    type: "success",
    title: `Data ${action}!`,
    confirmBtnBsStyle: "success",
    confirmBtnText: "Ok",
    message: "",
    showCancel: false,
    focusConfirmBtn: false,
  };
  if (res.data.message.data) {
    if (res.data.status !== 200) {
      isSucces = false;
      errorMessage = res.data.message.error;
    }
  } else {
    isSucces = false;
    errorMessage = res.data.message.error;
  }
  if (!isSucces) {
    if (errorMessage.includes("duplicate")) {
      errorMessage = "Data already exist";
    }
    param.type = "danger";
    param.title = "Attention!";
    param.confirmBtnBsStyle = "primary";
    param.message = errorMessage;
  }
  return {
    isSucces,
    param,
  };
};
